import { useMutation } from "react-query";
import { api } from "constants/RotasAPI";
import { http } from "shared/util/http";
import { AlertEdicaoReifnDTO } from "types/dto/reinf/AlertEdicaoReifnDTO";
import { VerificarImpactoReinfRequest } from "types/request/reinf/VerificarImpactoReinfRequest";

const verificarImpactoReinf = async (data: VerificarImpactoReinfRequest): Promise<AlertEdicaoReifnDTO> => {
  const response = await http.post<AlertEdicaoReifnDTO>(api.reinf.verificarImpactoReinf, data);
  return response.data;
};

export const usePostVerificarImpactoNaReinf = () => {
  return useMutation<AlertEdicaoReifnDTO, Error, VerificarImpactoReinfRequest>(verificarImpactoReinf);
};
